<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Add Model"
    icon="add"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    :isLoading="isLoading"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="Model Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlAutoComplete
              :items="enabledManufacturerList"
              autocomplete
              item-text="name"
              item-value="id"
              v-model="manufacturerId"
              clearable
              label="Model Manufacturer*"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlAutoComplete
              :items="enabledCategoryList"
              autocomplete
              item-text="name"
              item-value="id"
              v-model="categoryId"
              clearable
              label="Model Category*"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlAutoComplete,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    name: null,
    categoryId: null,
    manufacturerId: null,
  }),
  computed: {
    enabledCategoryList() {
      return this.categoryList.filter((category) => category.isEnabled)
    },
    enabledManufacturerList() {
      return this.manufacturerList.filter(
        (manufacturer) => manufacturer.isEnabled
      )
    },
  },
  watch: {
    showDialog() {
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        name: this.name,
        categoryId: this.categoryId,
        manufacturerId: this.manufacturerId,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.name = null
      this.categoryId = null
      this.manufacturerId = null
    },
  },
}
</script>